//
import WebComponent from '../src/webComponents/WebComponent';
import * as CursorSpinner from '../src/components/CursorSpinner';
import $ from 'jquery';
import {eshopUserToolsRefresh} from '../webActions/eshopUserToolsRefresh';

const fragments = {
  DEFAULT: 'button[type="submit"]',
  ADD: '[data-fragment="EshopOrderForm.add"]',
  REMOVE: '[data-fragment="EshopOrderForm.remove"]',
};

class EshopOrderForm extends WebComponent {
	constructor(props) {
		super(props);
		this.openingPopup = false;
		this.handleSubmit = this.handleSubmit.bind(this);
	}

	didMount() {
    const {
      queryAddButton,
    } = this.props;

    let query = fragments.DEFAULT;

    // pouzit selector dle fragmentu
    if (queryAddButton) {
      query = fragments.ADD;
    }

    this.submitButtons = this.element.querySelectorAll(query);

    if (this.submitButtons.length > 0) {
      for (let index in this.submitButtons) {
        if (this.submitButtons.hasOwnProperty(index)) {
          this.submitButtons[index].addEventListener('click', (e) => {
            this.handleSubmit(e, this.submitButtons[index]);
          });
        }
      }
    }
	}

	willUnMount() {
    if (this.submitButtons.length > 0) {
      for (let index in this.submitButtons) {
        if (this.submitButtons.hasOwnProperty(index)) {
          this.submitButtons[index].removeEventListener('click', this.handleSubmit);
        }
      }
    }
  }

  /**
	 * partial update after item has been put into shopping cart
	 */
	handleSubmit(e, item) {
		e.preventDefault();

		if (!this.openingPopup) {
      this.openingPopup = true;
      CursorSpinner.pushToQueue('addItemToBasket');
      let postUrl = item.getAttribute('formaction');
      let popupOpened = false;
      const currentPopup = document.querySelector('.esp__target--add-to-cart');

      if (currentPopup) {
        popupOpened = true;
      }

      if (!postUrl) {
        postUrl = this.element.getAttribute('action');
      }

      if (postUrl.indexOf('?') === -1) {
        postUrl += '@pageContainer';
      } else {
        postUrl = postUrl.replace('?', '@pageContainer?');
      }

      $.post(postUrl, $(this.element).serialize(), (data) => {
        CursorSpinner.removeFromQueue('addItemToBasket');

        if (!popupOpened) {
          edeeshopPopup.createPopup(data, 'esp__target--add-to-cart esp-add-to-cart');
          document.querySelector('.esp-add-to-cart .btn-next').focus();
        }
        else {

          const freeShippingWidget =  document.querySelector('.free-shipping');

          if (freeShippingWidget) {
            const freeShippingContent = $(data).find('.free-shipping');
            $('.free-shipping').replaceWith(freeShippingContent);
          }

          if (e.target) {
            e.target.innerHTML = this.i18n('addedProduct');
            e.target.classList.add('added-to-cart');
          }
        }
        eshopUserToolsRefresh();
        this.openingPopup = false;
      });
    }
	}
}

export default EshopOrderForm;



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/components/EshopOrderForm.js